exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#bg-modal .modal-dialog {\r\n  max-width: 100% !important;\r\n  max-height: 100% !important;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  margin: 0;\r\n}\r\n\r\n#bg-modal .modal-content {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n#bg-modal .modal-body {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n}\r\n\r\n#bg-modal #bg-modal-graph {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/buffer-graph/components/buffer-graph-modal.component/buffer-graph-modal.component.css
// module id = ./src/app/buffer-graph/components/buffer-graph-modal.component/buffer-graph-modal.component.css
// module chunks = main